/* Maison Bosoni — la boutique se souvient de l'âge que vous avez regardé.

   La coulée en tête de page était un filet décoratif : un joli trait qui se
   remplit au défilement et ne dit rien. Elle prend maintenant la couleur du
   dernier balsamique choisi dans la verticale — le grenat clair du trois ans,
   le presque noir du cinquante. Une animation qui rapporte quelque chose de
   vrai sur le visiteur cesse d'être une décoration.

   Deux chemins, parce que les deux sections sont sur la même page d'accueil :
   l'événement, pour que le filet change pendant qu'on fait glisser le
   curseur, et sessionStorage, pour qu'il s'en souvienne à la visite suivante.

   Sans JavaScript, ou si le stockage est refusé, le filet garde la couleur de
   son réglage de section. Rien ne dépend de ce fichier. */

(function () {
  'use strict';

  var CLE = 'mb-age';

  function lire() {
    try {
      return JSON.parse(sessionStorage.getItem(CLE) || 'null');
    } catch (e) {
      // Navigation privée, stockage bloqué : ce n'est pas une erreur, c'est
      // un visiteur qui n'a rien laissé. On garde la couleur d'origine.
      return null;
    }
  }

  function teindre(couleur) {
    if (!couleur) return;
    var filets = document.querySelectorAll('.mb-coulee');
    for (var i = 0; i < filets.length; i += 1) {
      filets[i].style.setProperty('--mb-coulee-color', couleur);
    }
  }

  function poser() {
    var age = lire();
    if (age && age.couleur) teindre(age.couleur);
  }

  document.addEventListener('mb:age', function (e) {
    var d = e.detail || {};
    if (!d.couleur) return;
    teindre(d.couleur);
    try {
      sessionStorage.setItem(CLE, JSON.stringify(d));
    } catch (err) {
      // Rien à faire : la teinte est posée pour cette page, elle ne
      // survivra pas à la suivante. C'est acceptable.
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poser);
  } else {
    poser();
  }

  // Les sections sont re-rendues dans l'éditeur de thème.
  document.addEventListener('shopify:section:load', poser);
})();
